var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _path8, _rect6, _rect7, _rect8, _path9, _rect9, _rect10, _rect11, _path10, _rect12, _rect13, _rect14, _path11, _path12, _path13, _rect15, _path14, _path15, _rect16, _rect17, _rect18, _rect19, _path16, _path17, _rect20, _rect21, _rect22, _path18, _rect23, _rect24, _rect25, _path19, _path20, _rect26, _rect27, _rect28, _path21, _rect29, _rect30, _path22, _rect31, _rect32, _path23, _path24, _path25, _path26, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _path27, _path28, _rect42, _rect43, _rect44, _path29, _path30, _rect45, _rect46, _rect47, _path31, _path32, _rect48, _rect49, _rect50, _path33, _path34, _rect51, _rect52, _rect53, _path35, _path36, _rect54, _rect55, _rect56, _path37, _path38, _path39, _path40, _path41, _path42, _rect57, _rect58, _rect59, _rect60, _rect61, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _rect62, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _rect63, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 189,
    viewBox: "0 0 231 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.764 46.9803C226.589 46.8531 226.175 46.808 225.982 46.7699C225.18 46.6118 224.353 46.543 223.535 46.543C221.014 46.5467 218.451 46.7943 215.972 47.2227C214.397 47.4946 212.494 48.4099 210.928 47.9128C208.199 47.0468 205.442 47.0893 202.853 48.3257C200.486 49.4562 198.69 51.6034 197.641 53.9235C197.483 54.2737 196.841 55.5627 196.659 56.4317C196.582 56.6093 196.507 56.7882 196.44 56.9698C196.249 57.4853 196.078 58.0098 195.919 58.5354C195.851 58.7596 195.68 59.2547 195.883 59.3504C195.558 59.949 195.271 60.566 195.031 61.203C194.335 63.0554 193.573 65.0874 193.328 67.0508C193.238 67.7778 193.234 68.5091 193.319 69.2375C193.36 69.5975 193.343 70.3216 193.587 70.5953C194.105 71.1762 194.371 70.363 194.313 69.9757C193.867 67.0236 194.728 64.2515 195.748 61.4766C196.408 59.6822 197.493 58.0406 198.707 56.5539C199.69 55.3505 200.745 54.4029 202.092 53.605C203.74 52.6294 205.502 51.8406 207.247 51.0494C208.396 50.5288 209.545 50.0222 210.725 49.5737C210.988 49.4739 211.4 49.2181 211.691 49.2171C212.307 49.2148 213.179 49.6689 213.773 49.8378C215.728 50.3936 217.708 51.1052 219.728 51.389C221.024 51.5712 222.238 51.3661 223.45 50.9344C223.574 50.8904 223.781 50.777 224.036 50.6151C224.935 50.269 225.787 49.8334 226.528 49.2049C226.955 48.8428 227.342 48.3749 227.696 47.9466C227.801 47.8185 227.848 47.6717 227.85 47.5323C227.93 47.4904 227.983 47.4415 227.995 47.3845C228.083 46.9629 227.279 46.9552 226.764 46.9803Z",
    fill: "#89C5CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9224 82.1207C21.4276 82.5213 20.9424 82.9305 20.4691 83.3562C20.1083 83.6808 19.4699 84.0692 19.3404 84.5608C19.2057 85.0716 19.6308 85.5498 19.9665 85.8587C21.7421 87.4922 23.7414 88.5966 26.2017 88.7803C29.99 89.0631 33.2869 88.0958 36.5738 86.1922C38.8826 84.8551 40.412 82.8772 40.746 80.2065C43.4956 81.3493 46.155 82.9244 48.4149 84.8576C49.53 85.8115 50.4904 86.8683 51.3787 88.0397C51.9476 88.7902 52.498 89.5527 53.0087 90.3445C53.2307 90.6885 53.4564 91.2986 53.8229 91.4967C54.2532 91.7295 54.7732 91.3647 54.7519 90.8863C54.7342 90.4881 54.3042 90.0263 54.1032 89.7008C53.7692 89.1603 53.4304 88.6232 53.0735 88.0976C52.496 87.2466 51.8991 86.4075 51.2481 85.6111C49.7852 83.8217 47.9237 82.3435 45.9941 81.083C42.2923 78.6647 38.2296 77.1413 33.7253 77.0122C30.9557 76.9328 28.6257 77.8791 26.2572 79.2922C24.7827 80.172 23.2604 81.0371 21.9224 82.1207Z",
    fill: "#DDE3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8493 70.423C54.963 67.4507 52.0668 64.5153 48.8422 61.898C46.9418 60.3557 44.939 58.9533 42.9774 57.4909C43.2039 57.6892 43.4258 57.8932 43.6424 58.1021C43.0302 57.6865 42.2287 57.4516 41.5795 57.0669C40.8555 56.6378 40.1634 56.1469 39.4845 55.6522C38.1594 54.6866 36.8541 53.7027 35.492 52.7874C33.9744 51.7678 32.4016 50.8257 30.8582 49.8445C29.5483 49.0118 28.2223 48.1004 26.821 47.4197C26.0572 47.0487 25.2916 46.6088 24.5247 46.2219C24.2681 46.0924 21.6637 44.4479 21.6703 44.4429C21.8142 44.3344 23.1248 44.9502 23.3274 45.0331C23.9195 45.2749 24.4857 45.5641 25.0549 45.8525C24.7425 45.2362 24.4952 44.5888 24.3605 43.9072C24.319 43.6969 23.9858 42.1655 24.1562 42.037C24.2414 41.9728 25.0723 44.7127 25.1149 44.9762C25.1494 45.1901 25.1444 45.4983 25.2144 45.7009C25.3275 46.0281 25.3218 45.9293 25.5709 46.1136C26.0275 46.4515 26.6336 46.6627 27.1278 46.9451C27.3942 47.0939 28.2193 47.6838 28.7163 47.852C30.2199 48.5823 31.744 49.7058 33.1727 50.6387C32.7977 49.934 32.5124 49.1971 32.3043 48.4249C32.2548 48.2416 31.7208 46.597 31.8504 46.4994C31.9962 46.3895 33.0136 48.9013 33.0739 49.1391C33.1858 49.5807 33.2091 50.0723 33.3492 50.5021C33.5031 50.9738 33.9832 51.141 34.416 51.416C36.008 52.4275 37.5455 53.5024 39.0573 54.6265C40.7068 51.6928 38.8048 48.1501 37.2018 45.6885C36.0464 43.9145 34.4908 42.3935 32.8484 41.0657C30.6565 39.2936 28.1486 37.8778 25.6438 36.5829C22.7252 35.074 19.5707 34.1391 16.2913 33.7072C14.5761 33.4812 12.8213 33.4876 11.0887 33.56C10.2424 33.5953 9.43001 33.7074 8.61894 33.9835C8.25338 34.108 7.90008 34.265 7.55579 34.4407C7.2942 34.5743 6.66139 34.7153 6.511 34.9142C5.2729 36.5257 4.6395 38.1315 4.73623 40.1564C4.82769 42.0733 5.43309 43.9911 6.25467 45.701C7.16963 47.6049 8.34642 49.3329 9.88544 50.7832C11.0596 51.8898 12.3724 52.8528 13.6765 53.8032C18.3148 57.1835 24.1954 60.1235 30.2028 59.3682C32.1475 59.1238 33.997 58.4437 35.7255 57.5196C36.1327 57.3019 36.5376 57.0816 36.922 56.8245C37.1813 56.6512 37.8742 55.8701 38.1349 55.8418C38.4922 55.8029 39.2621 56.5298 39.5974 56.751C42.1454 58.433 44.6266 60.2061 47.0559 62.0509C49.6404 64.0137 52.0982 66.11 54.4836 68.3049C55.4981 69.2384 56.5063 70.1741 57.4914 71.1391C57.7207 71.3635 58.2815 72.1902 58.6974 72.2277C58.9604 72.2513 59.1377 72.0268 59.1002 71.7835C59.0349 71.3604 58.1448 70.7273 57.8493 70.423Z",
    fill: "#C1DEE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.733 58.8881C222.615 58.6439 221.38 58.6626 220.241 58.6827C214.134 58.7658 208.136 61.6574 204.233 66.2777C200.91 70.211 199.996 75.1013 199.34 80.0448C199.275 80.5356 199.247 81.0233 199.21 81.5152C199.202 81.6207 199.191 81.7148 199.178 81.8035C198.92 82.0343 198.784 82.3034 198.937 82.599C198.368 83.8436 197.887 85.1198 197.475 86.436C196.26 90.3103 195.024 94.2582 195.785 98.3321C195.963 96.0902 196.337 93.7977 196.784 91.5926C196.81 91.466 196.838 91.3404 196.867 91.2152C196.87 91.202 196.873 91.1888 196.876 91.1757C197.034 90.5004 197.24 89.8454 197.49 89.2007C197.493 89.1936 197.495 89.1867 197.498 89.1797C197.531 89.0949 197.566 89.0105 197.601 88.9261C197.673 88.7514 197.746 88.577 197.825 88.4035C197.851 88.3444 197.876 88.2847 197.901 88.2246C198.265 87.3311 198.419 86.3244 198.746 85.3999C198.824 85.1897 198.906 84.9803 198.991 84.772C198.996 84.7598 199.001 84.7476 199.007 84.7354C199.238 84.1748 199.493 83.6211 199.764 83.0732C199.91 82.9628 199.989 82.689 200.115 82.4402C200.142 82.3911 200.346 82.0642 200.407 81.8758C200.567 81.568 200.725 81.2601 200.885 80.9528C200.881 80.9546 200.876 80.9564 200.871 80.9582C201.031 80.6631 201.192 80.3693 201.352 80.0767C201.387 80.0124 201.422 79.9481 201.458 79.8836C201.515 79.781 201.572 79.6784 201.629 79.5761C202.164 78.6187 202.732 77.6805 203.321 76.7539C203.531 76.4233 204.033 75.9491 204.13 75.5778C204.133 75.564 204.134 75.5512 204.136 75.5379C205.414 73.7426 206.886 72.0866 208.651 70.7745C208.437 71.0051 207.984 71.7876 207.864 71.9426C207.497 72.4169 207.099 72.8585 206.699 73.3055C205.983 74.1061 205.284 74.9322 204.663 75.8057C203.527 77.4033 202.547 79.0845 201.621 80.7996C201.612 80.8096 201.603 80.8191 201.594 80.8294C201.129 81.4033 200.836 82.2707 200.5 82.9272C201.827 82.3129 203.293 81.9127 204.654 81.3673C206.012 80.8235 207.332 80.2179 208.607 79.5068C210.302 78.5618 212.059 77.4947 213.66 76.2872C215.495 75.1491 217.037 73.5827 218.397 71.939C220.007 69.9941 221.483 68.0322 222.396 65.6708C222.844 64.5104 223.197 63.3003 223.406 62.0762C223.415 62.0228 223.426 61.965 223.439 61.9049C223.653 61.4821 223.844 61.0498 224.005 60.6075C224.26 59.9062 224.862 59.1346 223.733 58.8881Z",
    fill: "#69A1AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.202 148.201C233.365 169.613 156.659 183.578 90.6361 173.832C24.6134 164.086 -5.67464 126.025 25.8303 105.744C57.3352 85.4641 227.039 126.79 230.202 148.201Z",
    fill: "#DDE3E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.7617,
    y: 7.86719,
    width: 52.1155,
    height: 98.9867,
    rx: 8,
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6548 100.626C74.3702 100.626 76.5714 98.4249 76.5714 95.7095C76.5714 92.9942 74.3702 90.793 71.6548 90.793C68.9395 90.793 66.7383 92.9942 66.7383 95.7095C66.7383 98.4249 68.9395 100.626 71.6548 100.626Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3938 14.4224C67.7559 14.4224 68.0494 14.1289 68.0494 13.7669C68.0494 13.4048 67.7559 13.1113 67.3938 13.1113C67.0318 13.1113 66.7383 13.4048 66.7383 13.7669C66.7383 14.1289 67.0318 14.4224 67.3938 14.4224Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.6875,
    y: 13.1113,
    width: 6.88318,
    height: 1.31108,
    rx: 0.655541,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3477,
    y: 17.043,
    width: 42.938,
    height: 17.6996,
    rx: 4,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 22.3535,
    width: 23.9273,
    height: 2.65494,
    rx: 1.32747,
    fill: "#DDE3E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 26.7793,
    width: 16.0608,
    height: 2.65494,
    rx: 1.32747,
    fill: "#DDE3E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2301 29.8274C59.4024 29.8274 61.1634 28.0665 61.1634 25.8942C61.1634 23.7219 59.4024 21.9609 57.2301 21.9609C55.0579 21.9609 53.2969 23.7219 53.2969 25.8942C53.2969 28.0665 55.0579 29.8274 57.2301 29.8274Z",
    fill: "#C5CFD6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3477,
    y: 37.3652,
    width: 42.938,
    height: 13.7664,
    rx: 4,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 41.4961,
    width: 23.9273,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 44.9375,
    width: 16.0608,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2301 48.1829C59.4024 48.1829 61.1634 46.4219 61.1634 44.2497C61.1634 42.0774 59.4024 40.3164 57.2301 40.3164C55.0579 40.3164 53.2969 42.0774 53.2969 44.2497C53.2969 46.4219 55.0579 48.1829 57.2301 48.1829Z",
    fill: "#C5CFD6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3477,
    y: 53.7539,
    width: 42.938,
    height: 13.7664,
    rx: 4,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 57.8848,
    width: 23.9273,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 61.3262,
    width: 16.0608,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2301 64.5716C59.4024 64.5716 61.1634 62.8106 61.1634 60.6383C61.1634 58.4661 59.4024 56.7051 57.2301 56.7051C55.0579 56.7051 53.2969 58.4661 53.2969 60.6383C53.2969 62.8106 55.0579 64.5716 57.2301 64.5716Z",
    fill: "#AFB9C5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3477,
    y: 70.1426,
    width: 42.938,
    height: 13.7664,
    rx: 4,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 74.2734,
    width: 23.9273,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1328,
    y: 77.7148,
    width: 16.0608,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2301 80.9602C59.4024 80.9602 61.1634 79.1993 61.1634 77.027C61.1634 74.8547 59.4024 73.0938 57.2301 73.0938C55.0579 73.0938 53.2969 74.8547 53.2969 77.027C53.2969 79.1993 55.0579 80.9602 57.2301 80.9602Z",
    fill: "#C5CFD6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6407 87.8438C55.2064 87.8438 54.7735 87.8525 54.3398 87.875C54.0092 87.8923 53.504 87.8238 53.2243 88.0298C52.9337 88.2438 52.9537 88.682 52.9991 88.9914C53.2391 90.6275 53.8249 92.0783 55.0504 93.2374C56.9372 95.0223 59.1003 95.9292 61.66 96.333C63.458 96.6167 65.1178 96.2228 66.4414 94.9442C67.4085 96.7391 68.1422 98.7254 68.5103 100.73C68.6919 101.719 68.7473 102.697 68.7154 103.704C68.6949 104.349 68.6593 104.993 68.5901 105.635C68.5601 105.914 68.4179 106.336 68.5271 106.6C68.6553 106.909 69.0876 106.939 69.2817 106.675C69.4432 106.456 69.4135 106.024 69.4467 105.764C69.5017 105.332 69.5526 104.9 69.589 104.466C69.6482 103.763 69.692 103.059 69.6888 102.354C69.6814 100.769 69.3292 99.1789 68.8473 97.6751C67.923 94.7899 66.4233 92.2258 64.0908 90.214C62.6566 88.9769 61.0152 88.4759 59.153 88.207C57.9935 88.0396 56.8152 87.8438 55.6407 87.8438Z",
    fill: "#89C5CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3361 99.3145C57.6493 99.3145 54.4928 103.092 53.0003 107.018C52.4377 108.497 52.3058 110.122 52.089 111.676C52.0194 112.175 52.0452 112.935 51.8428 113.379C51.7693 113.54 51.6009 113.598 51.6815 113.817C51.7302 113.95 51.8258 114.032 51.9694 114.058C52.2642 114.112 52.6811 113.791 52.9338 113.664C55.0303 112.613 56.4077 110.987 57.5313 108.998C58.2279 107.766 58.9346 106.486 59.3484 105.132C59.6011 104.306 59.7483 103.435 59.8347 102.577C59.8687 102.239 59.9016 101.893 59.8996 101.554C59.8976 101.216 59.7407 101.038 59.628 100.745C61.1918 100.153 62.957 99.9915 64.5411 100.605C66.0062 101.172 67.2233 102.269 67.9048 103.646C68.0819 104.004 68.2184 104.382 68.3179 104.767C68.383 105.019 68.3861 105.347 68.5068 105.575C68.7993 106.128 69.4149 105.758 69.3558 105.243C69.191 103.807 68.3694 102.366 67.3194 101.367C65.995 100.108 64.1999 99.3145 62.3361 99.3145Z",
    fill: "#89C5CC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3945,
    y: 16.3887,
    width: 52.1155,
    height: 98.9867,
    rx: 8,
    fill: "#DDE3E9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2877 109.148C96.003 109.148 98.2042 106.946 98.2042 104.231C98.2042 101.516 96.003 99.3145 93.2877 99.3145C90.5723 99.3145 88.3711 101.516 88.3711 104.231C88.3711 106.946 90.5723 109.148 93.2877 109.148Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0266 22.9439C89.3887 22.9439 89.6822 22.6504 89.6822 22.2884C89.6822 21.9263 89.3887 21.6328 89.0266 21.6328C88.6646 21.6328 88.3711 21.9263 88.3711 22.2884C88.3711 22.6504 88.6646 22.9439 89.0266 22.9439Z",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3203,
    y: 21.6328,
    width: 6.88318,
    height: 1.31108,
    rx: 0.655541,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9805,
    y: 25.5664,
    width: 42.938,
    height: 17.6996,
    rx: 4,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9297,
    y: 30.875,
    width: 23.9273,
    height: 2.65494,
    rx: 1.32747,
    fill: "#DDE3E9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9297,
    y: 35.3008,
    width: 16.0608,
    height: 2.65494,
    rx: 1.32747,
    fill: "#DDE3E9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.33 36.7099C111.597 36.7099 112.624 35.6826 112.624 34.4155C112.624 33.1483 111.597 32.1211 110.33 32.1211C109.062 32.1211 108.035 33.1483 108.035 34.4155C108.035 35.6826 109.062 36.7099 110.33 36.7099Z",
    fill: "#DDE3E9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.331 35.4002C110.874 35.4002 111.314 34.96 111.314 34.4169C111.314 33.8738 110.874 33.4336 110.331 33.4336C109.788 33.4336 109.348 33.8738 109.348 34.4169C109.348 34.96 109.788 35.4002 110.331 35.4002Z",
    fill: "#F2F2F2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9805,
    y: 45.8867,
    width: 42.938,
    height: 13.7664,
    rx: 4,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7656,
    y: 50.0176,
    width: 23.9273,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7656,
    y: 53.459,
    width: 16.0608,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8629 56.7044C81.0352 56.7044 82.7962 54.9434 82.7962 52.7711C82.7962 50.5989 81.0352 48.8379 78.8629 48.8379C76.6907 48.8379 74.9297 50.5989 74.9297 52.7711C74.9297 54.9434 76.6907 56.7044 78.8629 56.7044Z",
    fill: "#C5CFD6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9805,
    y: 62.2773,
    width: 42.938,
    height: 13.7664,
    rx: 4,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9297,
    y: 66.4062,
    width: 23.9273,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9297,
    y: 69.8477,
    width: 16.0608,
    height: 2.06496,
    rx: 1.03248,
    fill: "#AFB9C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.33 71.454C111.597 71.454 112.624 70.4268 112.624 69.1596C112.624 67.8925 111.597 66.8652 110.33 66.8652C109.062 66.8652 108.035 67.8925 108.035 69.1596C108.035 70.4268 109.062 71.454 110.33 71.454Z",
    fill: "#DDE3E9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.331 70.1424C110.874 70.1424 111.314 69.7022 111.314 69.1591C111.314 68.616 110.874 68.1758 110.331 68.1758C109.788 68.1758 109.348 68.616 109.348 69.1591C109.348 69.7022 109.788 70.1424 110.331 70.1424Z",
    fill: "#F2F2F2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9805,
    y: 78.6641,
    width: 42.938,
    height: 13.7664,
    rx: 4,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7656,
    y: 82.7949,
    width: 23.9273,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7656,
    y: 86.2363,
    width: 16.0608,
    height: 2.06496,
    rx: 1.03248,
    fill: "#DDE3E9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8629 89.4817C81.0352 89.4817 82.7962 87.7208 82.7962 85.5485C82.7962 83.3762 81.0352 81.6152 78.8629 81.6152C76.6907 81.6152 74.9297 83.3762 74.9297 85.5485C74.9297 87.7208 76.6907 89.4817 78.8629 89.4817Z",
    fill: "#C5CFD6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0273,
    y: 24.582,
    width: 109.803,
    height: 113.409,
    rx: 8,
    fill: "#F2F2F2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 170.641,
    y: 38.6758,
    width: 22.9439,
    height: 26.5494,
    rx: 8,
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.112 54.0824C185.008 54.0824 187.356 51.7344 187.356 48.8381C187.356 45.9417 185.008 43.5938 182.112 43.5938C179.215 43.5938 176.867 45.9417 176.867 48.8381C176.867 51.7344 179.215 54.0824 182.112 54.0824Z",
    fill: "#DDE3E9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 173.918,
    y: 55.3926,
    width: 16.3885,
    height: 1.96662,
    rx: 0.983312,
    fill: "#DDE3E9"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 176.539,
    y: 58.6719,
    width: 11.1442,
    height: 1.96662,
    rx: 0.983312,
    fill: "#DDE3E9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0273 32.582C89.0273 28.1638 92.6091 24.582 97.0273 24.582H190.831C195.249 24.582 198.831 28.1638 198.831 32.582V33.4318H89.0273V32.582Z",
    fill: "#C5CFD6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2876 30.4815C94.0117 30.4815 94.5987 29.8945 94.5987 29.1705C94.5987 28.4464 94.0117 27.8594 93.2876 27.8594C92.5636 27.8594 91.9766 28.4464 91.9766 29.1705C91.9766 29.8945 92.5636 30.4815 93.2876 30.4815Z",
    fill: "#F2F2F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2212 30.4815C97.9453 30.4815 98.5323 29.8945 98.5323 29.1705C98.5323 28.4464 97.9453 27.8594 97.2212 27.8594C96.4971 27.8594 95.9102 28.4464 95.9102 29.1705C95.9102 29.8945 96.4971 30.4815 97.2212 30.4815Z",
    fill: "#F2F2F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.155 30.4815C101.879 30.4815 102.466 29.8945 102.466 29.1705C102.466 28.4464 101.879 27.8594 101.155 27.8594C100.431 27.8594 99.8438 28.4464 99.8438 29.1705C99.8438 29.8945 100.431 30.4815 101.155 30.4815Z",
    fill: "#F2F2F2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 170.641,
    y: 67.8477,
    width: 22.9439,
    height: 63.5875,
    rx: 8,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 176.539,
    y: 73.748,
    width: 11.1442,
    height: 8.52204,
    rx: 4,
    fill: "#DDE3E9"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 176.539,
    y: 84.8926,
    width: 11.1442,
    height: 8.19427,
    rx: 4,
    fill: "#AFB9C5"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 176.539,
    y: 95.709,
    width: 11.1442,
    height: 8.19427,
    rx: 4,
    fill: "#DDE3E9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 176.539,
    y: 117.342,
    width: 11.1442,
    height: 8.19427,
    rx: 4,
    fill: "#DDE3E9"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 176.539,
    y: 106.525,
    width: 11.1442,
    height: 8.19427,
    rx: 4,
    fill: "#C5CFD6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 94.2695,
    y: 39.0039,
    width: 73.7484,
    height: 15.4052,
    rx: 4,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 43.627,
    width: 54.7377,
    height: 2.31078,
    rx: 1.15539,
    fill: "#DDE3E9"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 47.4766,
    width: 36.7417,
    height: 2.31078,
    rx: 1.15539,
    fill: "#DDE3E9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.138 49.0029C161.405 49.0029 162.433 47.9756 162.433 46.7085C162.433 45.4413 161.405 44.4141 160.138 44.4141C158.871 44.4141 157.844 45.4413 157.844 46.7085C157.844 47.9756 158.871 49.0029 160.138 49.0029Z",
    fill: "#DDE3E9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.136 47.6912C160.679 47.6912 161.119 47.251 161.119 46.7079C161.119 46.1649 160.679 45.7246 160.136 45.7246C159.593 45.7246 159.152 46.1649 159.152 46.7079C159.152 47.251 159.593 47.6912 160.136 47.6912Z",
    fill: "#F2F2F2"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 94.2695,
    y: 57.0312,
    width: 73.7484,
    height: 12.7831,
    rx: 4,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 60.8672,
    width: 54.7377,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 64.0625,
    width: 36.7417,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.138 65.7177C161.405 65.7177 162.433 64.6905 162.433 63.4233C162.433 62.1561 161.405 61.1289 160.138 61.1289C158.871 61.1289 157.844 62.1561 157.844 63.4233C157.844 64.6905 158.871 65.7177 160.138 65.7177Z",
    fill: "#DDE3E9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.136 64.408C160.679 64.408 161.119 63.9678 161.119 63.4247C161.119 62.8817 160.679 62.4414 160.136 62.4414C159.593 62.4414 159.152 62.8817 159.152 63.4247C159.152 63.9678 159.593 64.408 160.136 64.408Z",
    fill: "#F2F2F2"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 94.2695,
    y: 72.4375,
    width: 73.7484,
    height: 12.7831,
    rx: 4,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 76.2734,
    width: 54.7377,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 79.4688,
    width: 36.7417,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.138 81.1239C161.405 81.1239 162.433 80.0967 162.433 78.8296C162.433 77.5624 161.405 76.5352 160.138 76.5352C158.871 76.5352 157.844 77.5624 157.844 78.8296C157.844 80.0967 158.871 81.1239 160.138 81.1239Z",
    fill: "#DDE3E9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.136 79.8123C160.679 79.8123 161.119 79.3721 161.119 78.829C161.119 78.2859 160.679 77.8457 160.136 77.8457C159.593 77.8457 159.152 78.2859 159.152 78.829C159.152 79.3721 159.593 79.8123 160.136 79.8123Z",
    fill: "#AFB9C5"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 94.2695,
    y: 118.652,
    width: 73.7484,
    height: 12.7831,
    rx: 4,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 122.488,
    width: 54.7377,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 125.684,
    width: 36.7417,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.138 127.339C161.405 127.339 162.433 126.312 162.433 125.044C162.433 123.777 161.405 122.75 160.138 122.75C158.871 122.75 157.844 123.777 157.844 125.044C157.844 126.312 158.871 127.339 160.138 127.339Z",
    fill: "#DDE3E9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.136 126.027C160.679 126.027 161.119 125.587 161.119 125.044C161.119 124.501 160.679 124.061 160.136 124.061C159.593 124.061 159.152 124.501 159.152 125.044C159.152 125.587 159.593 126.027 160.136 126.027Z",
    fill: "#F2F2F2"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 94.2695,
    y: 103.248,
    width: 73.7484,
    height: 12.7831,
    rx: 4,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 107.082,
    width: 54.7377,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 110.277,
    width: 36.7417,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.138 111.933C161.405 111.933 162.433 110.905 162.433 109.638C162.433 108.371 161.405 107.344 160.138 107.344C158.871 107.344 157.844 108.371 157.844 109.638C157.844 110.905 158.871 111.933 160.138 111.933Z",
    fill: "#DDE3E9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.136 110.623C160.679 110.623 161.119 110.183 161.119 109.64C161.119 109.096 160.679 108.656 160.136 108.656C159.593 108.656 159.152 109.096 159.152 109.64C159.152 110.183 159.593 110.623 160.136 110.623Z",
    fill: "#F2F2F2"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 94.2695,
    y: 87.8438,
    width: 73.7484,
    height: 12.7831,
    rx: 4,
    fill: "white"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 91.6777,
    width: 54.7377,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2188,
    y: 94.873,
    width: 36.7417,
    height: 1.91746,
    rx: 0.958729,
    fill: "#DDE3E9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.138 96.5282C161.405 96.5282 162.433 95.501 162.433 94.2338C162.433 92.9667 161.405 91.9395 160.138 91.9395C158.871 91.9395 157.844 92.9667 157.844 94.2338C157.844 95.501 158.871 96.5282 160.138 96.5282Z",
    fill: "#DDE3E9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.136 95.2166C160.679 95.2166 161.119 94.7764 161.119 94.2333C161.119 93.6902 160.679 93.25 160.136 93.25C159.593 93.25 159.152 93.6902 159.152 94.2333C159.152 94.7764 159.593 95.2166 160.136 95.2166Z",
    fill: "#F2F2F2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.028 80.4267C224.735 79.55 223.016 79.3203 221.469 79.3203C215.426 79.3203 209.746 81.5623 204.839 84.9029C202.151 86.7333 199.746 89.0643 197.622 91.4912C196.397 92.8922 195.304 94.4078 194.53 96.0933C194.008 97.231 193.649 98.4164 193.406 99.6391C193.11 101.129 192.875 102.649 192.769 104.164C192.727 104.761 192.38 107.926 193.372 107.98C193.367 108.058 193.365 108.132 193.371 108.199C191.218 111.566 189.887 115.513 188.653 119.254C187.58 122.51 186.623 125.794 186.002 129.162C185.185 133.597 184.648 138.098 184.392 142.596C184.337 143.563 184.3 144.53 184.267 145.498C184.24 146.324 184.212 147.15 184.185 147.975C184.155 148.901 183.992 149.966 184.139 150.886C184.267 151.687 184.96 151.566 184.991 150.768C185.028 149.806 185.022 148.841 185.064 147.878C185.12 146.599 185.178 145.32 185.24 144.042C185.676 135.162 187.31 126.413 190.326 118.025C191.546 114.63 192.945 111.417 194.742 108.277C196.322 105.516 198.223 102.844 200.166 100.354C202.055 97.9352 204.018 95.5721 206.332 93.5226C208.21 91.8594 210.276 90.4106 212.399 89.0624C215.095 87.3501 217.787 85.6794 220.708 84.365C222.227 83.6818 223.774 83.0702 225.304 82.4146C225.579 82.2967 225.875 82.1823 226.139 82.0457C227.023 81.5901 226.732 80.904 226.028 80.4267Z",
    fill: "#C1DEE2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.719 111.441C204.169 111.441 206.35 111.76 208.609 112.734C210.558 113.574 212.334 114.687 214.059 115.899C216.485 117.603 218.396 119.586 219.733 122.214C220.532 123.783 221.119 126.005 220.582 127.717C219.95 129.733 218.214 131.415 215.928 131.06C214.514 130.84 213.218 129.905 212.144 129.024C210.859 127.97 209.83 126.703 208.98 125.296C207.594 123.001 206.78 120.406 205.603 118.008C205.044 116.869 204.504 115.723 203.835 114.641C203.504 114.105 203.151 113.575 202.649 113.177C202.38 112.964 201.247 112.595 201.68 112.117C195.324 112.2 189.694 117.081 188.474 123.123C188.36 123.687 188.271 124.254 188.178 124.821C188.118 125.179 188.142 126.498 187.823 126.727C187.117 127.231 187.414 125.699 187.444 125.479C187.522 124.909 187.606 124.339 187.693 123.771C188.17 120.678 189.546 117.804 191.842 115.599C194.467 113.077 198.009 111.441 201.719 111.441Z",
    fill: "#89C5CC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0894 103.817C31.2077 114.081 38.3336 124.02 42.613 135.242C42.4405 133.92 42.2577 132.598 42.053 131.279C40.9672 124.284 39.6177 117.34 38.1996 110.405C37.4774 106.873 36.7136 103.355 35.9302 99.837C35.5089 97.9475 35.0927 96.0568 34.6627 94.1691C34.5585 93.7115 34.469 92.9129 34.3386 92.1035C38.4975 105.751 42.508 119.408 45.4416 133.384C45.8265 135.218 46.1542 137.049 46.4226 138.876C46.5145 138.459 46.6048 138.042 46.7037 137.627C47.8906 132.642 49.6711 127.697 51.7911 123.037C52.8046 120.808 53.9688 118.628 55.3394 116.597C56.1941 115.33 58.2098 113.825 58.9895 112.528C54.7253 120.349 53.1856 130.135 50.7234 138.638C50.1225 140.713 49.5178 142.785 48.9253 144.86C52.6383 137.414 58.3992 131.296 66.4088 128.644C56.7135 135.05 50.8981 146.269 46.9793 157.743C46.9664 157.879 46.951 158.015 46.9378 158.151C48.0909 155.963 49.5435 153.983 51.5122 152.597C55.7257 149.629 60.3999 150.493 64.4871 153.039C61.2793 151 55.4818 152.857 52.7828 154.93C50.8505 156.413 49.1992 158.403 47.7652 160.345C47.4216 160.811 46.9528 161.354 46.4576 161.933C45.7632 166.44 44.6317 170.917 43.0298 175.357C43.2941 174.083 43.103 172.044 43.1763 171.094C43.1843 170.991 43.1908 170.888 43.1987 170.786C42.9552 171.758 42.7199 172.719 42.4934 173.665C42.9437 171.86 43.1884 169.976 43.3794 168.073C43.4286 167.255 43.4766 166.437 43.5273 165.619C43.5112 164.067 43.4473 162.508 43.3392 160.947C42.9557 159.43 42.5264 157.999 42.1723 156.809C40.8947 152.515 39.0217 148.401 36.7164 144.563C34.613 141.061 32.0953 137.889 29.1888 135.02C27.6219 133.474 25.9821 132.001 24.3653 130.508C23.7807 129.968 22.7358 128.641 21.832 127.95C28.4138 131.578 35.1883 135.504 39.9897 141.35C39.4268 139.189 38.8154 137.058 38.1687 134.969C34.8875 124.374 30.7446 113.393 25.0894 103.817Z",
    fill: "#DDE3E9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6641 161.918C31.6641 173.684 32.5959 183.223 45.1027 183.223C57.6095 183.223 58.5413 173.684 58.5413 161.918",
    fill: "#C5CFD6"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 170.969,
    y: 10.4883,
    width: 1.96662,
    height: 8.19427,
    rx: 0.983312,
    fill: "#DDE3E9"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 175.559,
    y: 5.24414,
    width: 1.96662,
    height: 13.4386,
    rx: 0.983312,
    fill: "#DDE3E9"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 180.145,
    y: 2.62109,
    width: 1.96662,
    height: 16.0608,
    rx: 0.983312,
    fill: "#DDE3E9"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 184.734,
    y: 5.24414,
    width: 1.96662,
    height: 13.4386,
    rx: 0.983312,
    fill: "#DDE3E9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 189.324,
    width: 1.96662,
    height: 18.6829,
    rx: 0.983312,
    fill: "#C5CFD6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70631 100.382C9.70631 96.7306 12.6569 93.7422 16.2617 93.7422V100.382L11.7817 105.214C10.5074 104.033 9.70631 102.299 9.70631 100.382Z",
    fill: "#F2F2F2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.087 100.297H22.707C22.707 102.008 22.0089 103.612 20.9054 104.777C19.6916 106.051 17.9631 106.852 16.087 106.852C14.3588 106.852 12.7769 106.161 11.5628 105.068L16.087 100.297Z",
    fill: "#AFB9C5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.008 103.307C222.378 103.976 221.486 104.396 220.493 104.396C218.586 104.396 217.041 102.855 217.041 100.954C217.041 99.0535 218.586 97.5126 220.493 97.5126V91.1211C215.069 91.1211 210.629 95.547 210.629 100.954C210.629 106.361 215.069 110.787 220.493 110.787C223.343 110.787 225.918 109.586 227.673 107.674L223.008 103.307Z",
    fill: "#F2F2F2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.461 91.1211V97.5126C222.362 97.5126 223.903 99.0535 223.903 100.954H230.294C230.294 95.547 225.868 91.1211 220.461 91.1211Z",
    fill: "#AFB9C5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.773 100.953C223.773 102.07 223.247 103.062 222.43 103.703L226.449 108.82C228.788 106.988 230.296 104.149 230.296 100.953H223.773Z",
    fill: "#C5CFD6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.495 12.9482C160.01 13.4608 159.324 13.7827 158.561 13.7827C157.094 13.7827 155.905 12.6014 155.905 11.1442C155.905 9.68696 157.094 8.50564 158.561 8.50564V3.60547C154.388 3.60547 150.973 6.99865 150.973 11.1442C150.973 15.2897 154.388 18.6829 158.561 18.6829C160.752 18.6829 162.733 17.7617 164.083 16.2962L160.495 12.9482Z",
    fill: "#F2F2F2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.512 3.60547V8.50564C159.969 8.50564 161.15 9.68696 161.15 11.1442H166.05C166.05 6.99865 162.657 3.60547 158.512 3.60547Z",
    fill: "#AFB9C5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.159 11.1445C161.159 11.9821 160.765 12.7265 160.152 13.2072L163.167 17.0444C164.921 15.6707 166.052 13.5412 166.052 11.1445H161.159Z",
    fill: "#C5CFD6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1738 18.6787C41.1725 18.682 41.1712 18.6853 41.1692 18.6892C41.1712 18.686 41.1738 18.6728 41.1738 18.6787Z",
    fill: "#C5CFD6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1708 18.6837C41.1708 18.6844 41.1701 18.6857 41.1701 18.687C41.1701 18.6837 41.176 18.6739 41.1708 18.6837Z",
    fill: "#C5CFD6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1935 18.6283C41.1889 18.6414 41.183 18.6538 41.1778 18.6669C41.1804 18.6604 41.183 18.6552 41.1857 18.6486C41.1175 18.819 41.1608 18.7082 41.1935 18.6283Z",
    fill: "#C5CFD6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1789 18.6678C41.1762 18.6737 41.1736 18.6802 41.171 18.6861C41.152 18.7228 41.1789 18.6678 41.1789 18.6678Z",
    fill: "#C5CFD6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1681 18.6886C41.1641 18.6965 41.1864 18.6584 41.1681 18.6886V18.6886Z",
    fill: "#C5CFD6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1709 18.6839L41.1722 18.6826C41.1715 18.6832 41.1715 18.6839 41.1709 18.6839Z",
    fill: "#C5CFD6"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4375,
    y: 1.63867,
    width: 31.1382,
    height: 20.6496,
    rx: 4,
    fill: "#DDE3E9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2362 7.53906L28.0586 22.2887H46.4137L37.2362 7.53906Z",
    fill: "#AFB9C5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.253 11.4727L38.2227 22.2891H54.2834L46.253 11.4727Z",
    fill: "#C5CFD6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6921 11.4721C51.3213 11.4721 52.6421 10.1514 52.6421 8.5222C52.6421 6.893 51.3213 5.57227 49.6921 5.57227C48.0629 5.57227 46.7422 6.893 46.7422 8.5222C46.7422 10.1514 48.0629 11.4721 49.6921 11.4721Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.514 158.636C197.515 158.639 197.516 158.642 197.518 158.646C197.516 158.643 197.514 158.63 197.514 158.636Z",
    fill: "#C5CFD6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.517 158.641C197.517 158.641 197.517 158.643 197.517 158.644C197.517 158.641 197.511 158.631 197.517 158.641Z",
    fill: "#C5CFD6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.494 158.585C197.499 158.598 197.504 158.611 197.51 158.624C197.507 158.617 197.504 158.612 197.502 158.606C197.57 158.776 197.527 158.665 197.494 158.585Z",
    fill: "#C5CFD6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.509 158.625C197.511 158.631 197.514 158.637 197.517 158.643C197.536 158.68 197.509 158.625 197.509 158.625Z",
    fill: "#C5CFD6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.519 158.646C197.523 158.653 197.501 158.615 197.519 158.646V158.646Z",
    fill: "#C5CFD6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.517 158.641L197.515 158.64C197.516 158.64 197.516 158.641 197.517 158.641Z",
    fill: "#C5CFD6"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 46.5434,
    height: 30.8104,
    rx: 4,
    transform: "matrix(-1 0 0 1 220.789 133.402)",
    fill: "#DDE3E9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.508 142.252L216.965 164.213H190.052L203.508 142.252Z",
    fill: "#AFB9C5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.631 148.135L201.527 164.213H177.734L189.631 148.135Z",
    fill: "#C5CFD6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.571 148.153C182.127 148.153 180.146 146.171 180.146 143.728C180.146 141.284 182.127 139.303 184.571 139.303C187.015 139.303 188.996 141.284 188.996 143.728C188.996 146.171 187.015 148.153 184.571 148.153Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.306 94.5613L116.43 99.7771L120.222 104.635L129.117 97.8156C133.56 96.9996 134.65 96.1733 134.328 95.5872C134.058 95.0956 133.86 95.1046 133.664 95.1136C133.51 95.1207 133.357 95.1277 133.171 94.8894C133.074 94.7654 132.966 94.6809 132.87 94.6055C132.547 94.3522 132.357 94.2033 133.171 93.0145C134.227 91.472 132.44 91.5174 131.861 91.7018C131.004 92.1785 130.617 92.3874 130.271 92.6512C129.836 92.9842 129.467 93.4046 128.306 94.5613ZM75.1314 102.548L68.4149 101.215C63.8597 113.221 61.144 119.8 60.2678 120.953C59.6253 121.798 55.6627 123.974 52.9806 125.137C51.9041 125.603 52.1352 126.513 52.451 126.804C54.4426 128.64 56.2942 127.997 58.3097 127.296C58.8932 127.093 59.4904 126.886 60.1088 126.732C61.7093 126.335 62.1963 127.158 62.6566 127.936C63.0641 128.624 63.4507 129.277 64.5704 129.017C64.5195 128.797 64.457 128.551 64.3894 128.285C63.9529 126.567 63.3091 124.034 64.2642 122.563C64.7544 121.807 68.3768 115.136 75.1314 102.548Z",
    fill: "#B28B67"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M133.612 83.737C139.647 83.477 144.329 78.3736 144.069 72.3381C143.809 66.3027 138.706 61.6208 132.67 61.8808C126.635 62.1408 121.953 67.2443 122.213 73.2797C122.473 79.3151 127.576 83.997 133.612 83.737Z",
    fill: "#EDEACE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M134.261 83.8488L130.691 83.6484L130.256 91.4009L133.825 91.6013L134.261 83.8488Z",
    fill: "#343532"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M133.738 60.8181C131.358 60.6845 128.993 61.2594 126.94 62.4702C124.887 63.681 123.24 65.4734 122.206 67.6205C121.172 69.7677 120.797 72.1732 121.131 74.533C121.464 76.8928 122.489 79.1008 124.077 80.8779C125.665 82.6549 127.744 83.9212 130.052 84.5165C132.359 85.1119 134.792 85.0096 137.041 84.2226C139.291 83.4356 141.256 81.9992 142.689 80.0951C144.123 78.191 144.959 75.9047 145.093 73.5253C145.272 70.3345 144.176 67.2033 142.047 64.8203C139.917 62.4373 136.928 60.9977 133.738 60.8181ZM132.483 83.199C130.433 83.0837 128.462 82.3629 126.821 81.1278C125.181 79.8927 123.943 78.1987 123.265 76.2601C122.586 74.3216 122.498 72.2254 123.012 70.2368C123.525 68.2481 124.616 66.4563 126.147 65.0879C127.679 63.7195 129.582 62.8359 131.616 62.549C133.649 62.2621 135.722 62.5846 137.573 63.4759C139.423 64.3672 140.967 65.7871 142.011 67.5561C143.054 69.3252 143.549 71.3639 143.434 73.4144C143.357 74.776 143.013 76.109 142.42 77.3374C141.828 78.5658 141 79.6656 139.983 80.5739C138.966 81.4822 137.779 82.1812 136.492 82.6311C135.205 83.081 133.841 83.2728 132.48 83.1958L132.483 83.199Z",
    fill: "#64665F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.013 70.0518C138.535 68.9107 137.746 67.9271 136.735 67.2133C135.724 66.4995 134.533 66.0843 133.298 66.015C132.495 65.97 131.881 65.2829 131.926 64.4805C131.971 63.678 132.658 63.0639 133.461 63.109C135.241 63.2088 136.958 63.8072 138.414 64.8359C139.87 65.8646 141.008 67.2821 141.698 68.9265C142.387 70.571 142.6 72.3761 142.313 74.1359C142.025 75.8956 141.249 77.5391 140.072 78.8787C139.541 79.4825 138.622 79.5419 138.018 79.0115C137.414 78.481 137.355 77.5615 137.885 76.9576C138.702 76.0281 139.241 74.8877 139.44 73.6666C139.64 72.4455 139.492 71.1929 139.013 70.0518Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M131.205 107.874L131.149 107.872C130.79 107.852 130.438 107.761 130.114 107.605C129.79 107.449 129.5 107.23 129.26 106.962C129.02 106.694 128.836 106.381 128.717 106.041C128.598 105.701 128.548 105.342 128.568 104.982L129.416 89.9022C129.436 89.5429 129.527 89.191 129.683 88.8667C129.839 88.5424 130.057 88.252 130.325 88.0121C130.593 87.7722 130.906 87.5876 131.246 87.4688C131.586 87.3499 131.945 87.2992 132.305 87.3195L132.36 87.3238C132.719 87.3437 133.071 87.4343 133.395 87.5902C133.719 87.7462 134.009 87.9644 134.249 88.2326C134.489 88.5007 134.673 88.8135 134.792 89.1529C134.911 89.4924 134.962 89.852 134.942 90.2111L134.094 105.292C134.074 105.652 133.984 106.004 133.828 106.328C133.672 106.652 133.453 106.942 133.185 107.182C132.916 107.422 132.603 107.607 132.264 107.725C131.924 107.844 131.564 107.895 131.205 107.874Z",
    fill: "#8F91F7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M131.332 105.139L132.179 90.0579C132.206 89.5754 132.36 89.1085 132.626 88.705C132.892 88.3015 133.26 87.9757 133.693 87.7609C133.295 87.5015 132.836 87.351 132.361 87.3244L132.305 87.3202C131.946 87.2999 131.586 87.3506 131.247 87.4694C130.907 87.5883 130.594 87.7729 130.326 88.0128C130.058 88.2527 129.839 88.5431 129.683 88.8674C129.527 89.1917 129.437 89.5436 129.417 89.9029L128.569 104.983C128.548 105.342 128.599 105.702 128.718 106.042C128.837 106.381 129.021 106.694 129.261 106.963C129.501 107.231 129.791 107.449 130.115 107.606C130.439 107.762 130.791 107.852 131.15 107.873L131.206 107.875C131.681 107.902 132.154 107.804 132.58 107.591C132.174 107.329 131.845 106.964 131.626 106.533C131.406 106.103 131.305 105.622 131.332 105.139Z",
    fill: "#455984"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M141.294 80.374C142.795 78.7374 143.777 76.6926 144.115 74.4982C144.454 72.3038 144.134 70.0583 143.196 68.0456C142.259 66.0329 140.745 64.3434 138.847 63.1908C136.95 62.0382 134.753 61.4741 132.535 61.57C130.316 61.6659 128.176 62.4173 126.385 63.7294C124.594 65.0415 123.232 66.8552 122.471 68.9413C121.711 71.0274 121.586 73.2921 122.113 75.4491C122.639 77.6062 123.793 79.5586 125.43 81.0596C126.516 82.0565 127.789 82.8295 129.174 83.3346C130.559 83.8396 132.031 84.0668 133.504 84.0032C134.977 83.9395 136.424 83.5862 137.76 82.9635C139.097 82.3408 140.298 81.4609 141.294 80.374ZM132.48 83.1954C130.429 83.0801 128.459 82.3593 126.818 81.1242C125.177 79.8891 123.94 78.1952 123.261 76.2566C122.583 74.318 122.495 72.2218 123.008 70.2332C123.521 68.2445 124.613 66.4527 126.144 65.0843C127.676 63.7159 129.579 62.8324 131.612 62.5455C133.646 62.2585 135.719 62.5811 137.569 63.4723C139.42 64.3636 140.964 65.7835 142.007 67.5526C143.051 69.3216 143.546 71.3603 143.431 73.4109C143.276 76.1605 142.035 78.7361 139.982 80.5711C137.928 82.406 135.23 83.35 132.48 83.1954Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M133.39 91.67C133.777 90.763 134.934 90.0683 134.934 90.0683L134.764 93.7476C134.764 93.7476 134.758 94.3091 134.601 94.4589C134.444 94.6088 133.795 94.5359 133.459 93.7576C133.047 92.8034 133.002 92.577 133.39 91.67Z",
    fill: "#B28B67"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2335 71.1895C97.356 72.4688 99.4414 73.087 100.42 72.8346C102.875 72.2019 103.101 63.2216 101.201 59.6813C99.3021 56.141 89.5378 54.598 89.0456 61.6124C88.8748 64.0469 89.897 66.2195 91.4073 67.9924L88.6992 80.6148H96.5657L95.2335 71.1895Z",
    fill: "#B28B67"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5858 61.575C88.4078 61.5946 88.2268 61.6046 88.0435 61.6046C85.3282 61.6046 83.127 59.4034 83.127 56.688C83.127 53.9727 85.3282 51.7715 88.0435 51.7715C90.7355 51.7715 92.9222 53.935 92.9596 56.6181C96.9114 55.249 102.04 56.8489 101.353 60.0577C100.932 62.0267 98.7345 63.0539 96.4915 64.1024L96.4913 64.1025C96.3871 64.1512 96.2827 64.2 96.1785 64.2489C95.8329 63.6489 95.1738 63.2435 94.4176 63.2435C93.3031 63.2435 92.3996 64.1239 92.3996 65.2101C92.3996 65.6013 92.5168 65.9659 92.7189 66.2722C91.9291 66.9592 91.3718 67.7862 91.2371 68.8587C89.9641 68.8587 87.9066 65.1211 88.5858 61.575Z",
    fill: "#191847"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0762 110.115L98.4105 150.439L104.385 184.732H109.07L102.757 110.115H86.0762Z",
    fill: "#997659"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6632 110.115C82.501 132.255 81.515 143.675 81.3275 145.687C81.14 147.698 78.5725 160.741 72.4941 185.407L77.4862 183.692C87.0924 161.07 90.3659 149.313 91.4677 146.342C92.5694 143.372 95.4957 131.296 100.246 110.115H81.6632Z",
    fill: "#B28B67"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8157 183.799C73.6805 183.513 72.3823 183.923 72.1054 185.061C72.0314 185.365 71.9824 185.648 71.9824 185.866C71.9824 186.753 72.2778 188.453 72.2778 188.453C73.3063 188.453 90.7647 188.453 90.7647 188.453C90.7647 188.453 91.4853 186.071 89.9327 185.881C88.3802 185.691 87.3532 185.538 87.3532 185.538L79.3924 181.989C78.8778 181.76 78.2754 182.001 78.0607 182.521L77.7719 183.222C77.7719 183.222 76.3346 183.892 75.436 183.892C75.2561 183.892 75.0424 183.857 74.8157 183.799Z",
    fill: "#1C584D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.626 183.799C104.491 183.513 103.193 183.923 102.916 185.061C102.842 185.365 102.793 185.648 102.793 185.866C102.793 186.753 103.088 188.453 103.088 188.453C104.117 188.453 121.575 188.453 121.575 188.453C121.575 188.453 122.296 186.071 120.743 185.881C119.191 185.691 118.164 185.538 118.164 185.538L110.203 181.989C109.688 181.76 109.086 182.001 108.871 182.521L108.582 183.222C108.582 183.222 107.145 183.892 106.247 183.892C106.067 183.892 105.853 183.857 105.626 183.799Z",
    fill: "#1C584D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4375 110.115L89.6818 130.66H105.7L103.312 110.115H84.4375Z",
    fill: "#19383C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4863 110.115C78.898 117.874 80.503 130.66 80.503 130.66H96.849L101.344 110.115H81.4863Z",
    fill: "#254D52"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1863 76.084L96.0205 75.5979C102.194 81.5863 104.713 95.9733 108.827 97.8776C112.717 99.6781 118.231 97.9358 124.785 95.5832L126.792 100.068C120.837 106.51 108.15 111.954 103.008 108.846C94.7863 103.878 92.8882 86.134 93.1863 76.084Z",
    fill: "#506742"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.832 111.702C80.832 111.702 97.8786 111.702 105.91 111.702C107.056 111.702 106.84 110.047 106.675 109.212C104.763 99.5755 97.2997 89.1877 97.2997 75.4703L90.0659 74.3359C84.0827 83.9588 82.0136 95.8064 80.832 111.702Z",
    fill: "#DDE3E9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.681 74.3359H89.5984C73.3733 84.3344 63.5677 99.8334 60.1816 120.833L65.4382 121.863C68.9203 117.806 73.2175 111.167 78.3299 101.945C76.7614 107.5 75.6162 113.198 75.2591 118.585H97.8334C102.204 107.541 92.4626 74.3359 92.4626 74.3359H90.9041H89.681Z",
    fill: "#698C53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/emptySearch.f8bb2ed7f4cd3f26036b529d9e7f7710.svg";
export { ForwardRef as ReactComponent };